import React from "react";
import {Layout} from '../components/common/Layout';
import {useMutation} from '@apollo/client';
import {CREATE_LEAD} from '../api/lead/createLead'
import {RegisterForm} from '../components/register/RegisterForm';
import {NewUser} from '../components/register/types';
import {SuccessMessage} from '../components/register/SuccessMessage';

export const Register = () => {
    const [mutateFunction, { data, loading, error }] = useMutation(CREATE_LEAD)

    const onSubmit = (newUser: NewUser) => {
        mutateFunction({variables: {input: newUser}})
    }

    const isSuccessMessageVisible = data !== undefined && error === undefined

    return (
        <Layout
            isTitleHidden={isSuccessMessageVisible}
            maxWidth="sm"
            title="Register"
        >
            {isSuccessMessageVisible ? (
                <SuccessMessage/>
            ) : (
                <RegisterForm onSubmit={onSubmit} errorMessage={error?.message} isLoading={loading}/>
            )}
        </Layout>
    )
}
